import { apiSlice } from '../../../api/apiSlice';
import { GET_PROFILE_PHOTO } from '../../../constants';

export const profilePhotoSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getProfilePhoto: builder.query({
            query: (arg: any) => {
                const { email } = arg;
                return {
                    url: GET_PROFILE_PHOTO,
                    params: { email },
                };
            },
            // Profile photos rarely change within a session — override the app-wide
            // keepUnusedDataFor: 0 default so re-mounting (e.g. opening/closing the
            // profile popup) reuses the cached result instead of refetching every time.
            keepUnusedDataFor: 300,
            transformResponse: (response: any) => response?.data?.photo ?? null,
        }),
    }),
});

export const { useGetProfilePhotoQuery } = profilePhotoSlice;
